import { render } from "./FacilityLabels.vue?vue&type=template&id=d9ca150a&scoped=true"
import script from "./FacilityLabels.vue?vue&type=script&lang=js"
export * from "./FacilityLabels.vue?vue&type=script&lang=js"

import "./FacilityLabels.vue?vue&type=style&index=0&id=d9ca150a&scoped=true&lang=css"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9ca150a"]])

export default __exports__